'use client';

import { useInView } from 'react-intersection-observer';
import { type CSSProperties } from 'react';
import cn from 'classnames';
import styles from './animate-into-view.module.scss';

export type AnimateIntoViewMode =
	'fadeIn' | 'slideUp' | 'slideDown' | 'wacky' | 'brighten';

interface IUseAnimateIntoViewOptions {
	isLoading?: boolean;
	mode?: AnimateIntoViewMode;
	duration?: string;
}

const useAnimateIntoView = ({
	isLoading,
	mode = 'fadeIn',
	duration = '0.8s',
}: IUseAnimateIntoViewOptions = {}) => {
	const { ref, inView } = useInView({
		triggerOnce: true,
		threshold: 0,
	});

	const inViewClass = inView ? styles.end : styles.start;
	const loadingClass = isLoading ? styles.isLoading : null;

	return {
		ref,
		className: cn(styles[mode], styles.wrapper, inViewClass, loadingClass),
		style: { '--duration': duration } as CSSProperties,
	};
};

export default useAnimateIntoView;
